// UI stages may include SMS, but persisted API step IDs must stay 0..6.
import {catalogKey} from './CareerCatalog';
import {validRecordDate,monthValue,currentRecordMonth,apiRecordDate,recordPeriod,recordPeriodValid} from './recordMonths';
export const apiStages=['citizenship','identity','contact','education','experience','skills','review'];
export const stagesFor=form=>[...apiStages.slice(0,3),...(form?.tcVatandasiMi===true?['sms']:[]),...apiStages.slice(3,6),'photo','review'];
export function resumeStage(form) {
  const stages=stagesFor(form);
  if(form.tcVatandasiMi===true&&!form.telefonDogrulandi&&!form.tamamlandi&&form.adim>=3)return stages.indexOf('sms');
  if(form.adim>=6&&!form.tamamlandi&&form.profilFotografiVar!==true)return stages.indexOf('photo');
  return Math.max(0,stages.indexOf(apiStages[Math.min(6,Math.max(0,form.adim||0))]));
}
export const recordLists={egitim:'egitimler',deneyim:'deneyimler',dil:'diller',sertifika:'sertifikalar'};
export const dateValue=x=>x?String(x).slice(0,10):'';
export function statusKind(label) {
  return catalogKey('educationStatus',label);
}
export const statusName=(label,t)=>statusKind(label)?t(statusKind(label)):label;
export const hasDraft=value=>Object.values(value).some(v=>typeof v==='string'?!!v.trim():typeof v==='number'?v>0:v===true);
export function recordError(kind,value,form) {
  if(!hasDraft(value))return null;
  if(kind==='egitim') {
    if(!value.okul?.trim()||!form.kategoriler.some(x=>x.id===value.kategoriId)||!form.durumlar.some(x=>x.id===value.durumId))return 'incompleteEducation';
    if(statusKind(form.durumlar.find(x=>x.id===value.durumId)?.ad)!=='student'&&value.tarih&&(!validRecordDate(value.tarih)||monthValue(value.tarih)>currentRecordMonth()))return 'educationDateInvalid';
  }
  if(kind==='deneyim'&&(!value.sirket?.trim()||!value.pozisyon?.trim()||!validRecordDate(value.baslangic)||monthValue(value.baslangic)>currentRecordMonth()||(!value.devam&&(!validRecordDate(value.bitis)||!recordPeriodValid(value.baslangic,value.bitis)||monthValue(value.bitis)>currentRecordMonth()))))return 'incompleteExperience';
  if(kind==='dil'&&(!form.dilSecenekleri.some(x=>x.id===value.dilId)||!form.seviyeler.some(x=>x.id===value.seviyeId)))return 'incompleteLanguage';
  if(kind==='sertifika'&&!value.ad?.trim())return 'incompleteCertificate';
  return null;
}
export function recordIssues(kind,value,form,force=false){
  const issue=recordError(kind,value,form)||(force&&!hasDraft(value)?{egitim:'incompleteEducation',deneyim:'incompleteExperience',dil:'incompleteLanguage',sertifika:'incompleteCertificate'}[kind]:null);
  if(!issue)return {};
  const fields={};const add=(key,message=issue)=>{fields[kind+'.'+key]=message;};
  if(kind==='egitim'){
    if(!value.okul?.trim())add('okul');
    if(!form.kategoriler.some(x=>x.id===value.kategoriId))add('kategoriId');
    if(!form.durumlar.some(x=>x.id===value.durumId))add('durumId');
    if(issue==='educationDateInvalid')add('tarih');
  }
  if(kind==='deneyim'){
    if(!value.sirket?.trim())add('sirket');if(!value.pozisyon?.trim())add('pozisyon');
    if(!validRecordDate(value.baslangic)||monthValue(value.baslangic)>currentRecordMonth())add('baslangic','experienceStartInvalid');
    if(!value.devam&&(!validRecordDate(value.bitis)||!recordPeriodValid(value.baslangic,value.bitis)||monthValue(value.bitis)>currentRecordMonth()))add('bitis','experienceEndInvalid');
  }
  if(kind==='dil'){if(!form.dilSecenekleri.some(x=>x.id===value.dilId))add('dilId');if(!form.seviyeler.some(x=>x.id===value.seviyeId))add('seviyeId');}
  if(kind==='sertifika')add('ad');
  return fields;
}
export function recordPayload(kind,value,form) {
  if(kind==='egitim')return {...value,okul:value.okul.trim(),bolum:value.bolum?.trim(),tarih:statusKind(form.durumlar.find(x=>x.id===value.durumId)?.ad)==='student'?null:apiRecordDate(value.tarih)};
  if(kind==='deneyim')return {...value,sirket:value.sirket.trim(),pozisyon:value.pozisyon.trim(),...recordPeriod(value.baslangic,value.devam?null:value.bitis)};
  if(kind==='sertifika')return {...value,ad:value.ad.trim(),aciklama:value.aciklama?.trim()};
  return value;
}
